import { TravelPricing } from '../../common/models/TravelPrincing';
import { TravelPricingResponse } from '../models/responses/TravelPricingResponse';

export const TravelPricingMapper = (
  data: TravelPricingResponse
): TravelPricing => {
  return {
    id: data._id,
    currency: data.currency,
    typeVehicle: data.typeVehicle,
    baseFee: data.base_fee,
    costPerKm: data.cost_per_km,
    costPerMinute: data.cost_per_minute,
    pickupFee: data.pickup_fee,
    dropoffFee: data.dropoff_fee,
    surgeMultiplier: data.surge_multiplier,
    minimumFare: data.minimum_fare,
    cancellationFee: data.cancellation_fee,
    distanceThresholdKm: data.distance_threshold_km,
    isActive: data.is_active,
    rule: data.rule
      ? {
          weekDay: data.rule.week_day ?? null,
          validTimeRange: data.rule.valid_time_range
            ? {
                start: data.rule.valid_time_range.start,
                end: data.rule.valid_time_range.end,
              }
            : null,
          geofence: data.rule.geofence ?? null,
        }
      : null,
  };
};
